/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Addresscity2Inputs */

const ja_company_companydetails_addresscity2 = /** @type {(inputs: Company_Companydetails_Addresscity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西五反田7-22-17`)
};

const en_company_companydetails_addresscity2 = /** @type {(inputs: Company_Companydetails_Addresscity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokyo`)
};

/**
* | output |
* | --- |
* | "Tokyo" |
*
* @param {Company_Companydetails_Addresscity2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_addresscity2 = /** @type {((inputs?: Company_Companydetails_Addresscity2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Addresscity2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_addresscity2(inputs)
	return en_company_companydetails_addresscity2(inputs)
});
export { company_companydetails_addresscity2 as "company_companyDetails_addressCity" }